import { RefObject, useEffect } from "react";

export function useOnClickOutside(
  elements: RefObject<Node>[],
  // element: RefObject<Node>,
  callback: () => void,
  event: "click" | "mousedown" = "mousedown"
) {
  useEffect(() => {
    const onClick = (event: Event) => {
      if (
        event.target instanceof Node &&
        elements.every((v) => !v.current?.contains(event.target as Node))
        // !element.current?.contains(event.target)
      ) {
        callback();
      }
    };
    document.addEventListener(event, onClick);
    return () => document.removeEventListener(event, onClick);
  }, []);
}
